<template>
  <div
    class="
      cruise-modal-itinerary-card
      tw-w-full
      lg:tw-max-w-56r
      xl:tw-max-w-63.5r
      2xl:tw-max-w-70.75r
      lg:tw-mx-auto lg:tw-h-67px
      xl:tw-h-75px
    "
  >
    <div
      class="
        cruise-modal-itinerary-card--wrapper
        tw-flex tw-flex-2 tw-justify-between tw-h-full tw-w-full
      "
    >
      <div
        class="
          cruise-modal-itinerary-card__img-container
          lg:tw-w-[284px]
          xl:tw-w-[366px]
        "
      >
        <VueImage
          :src="itineraryLogo"
          :width="'auto'"
          :height="'100%'"
          :alt="cruiseItineraryLogoAlt"
          :extraClasses="{ 'lg:tw-object-cover': true, 'lg:tw-w-full': true }"
        ></VueImage>
        <Ribbons :ribbons="ribbons" :demo-mode="demoMode" />
      </div>
      <div
        class="
          cruise-modal-itinerary-card__description
          tw-flex tw-flex-nowrap tw-flex-col tw-justify-center tw-grow tw-pl-5
        "
      >
        <h3
          class="
            cruise-modal-itinerary-card__description__title
            tw-mb-0 tw-text-sm
          "
        >
          {{ itineraryName }}
        </h3>
        <div
          class="
            cruise-modal-itinerary-card__description__time
            tw-flex tw-flex-nowrap tw-text-xs
          "
        >
          <img class="tw-pr-2" :src="require('@/assets/icons/calendar.svg')" />
          <p class="tw-whitespace-nowrap tw-mb-0">{{ getDatesLabel }}</p>
          <p
            class="
              cruise-modal-itinerary-card__description__time__nights
              tw-mb-0 tw-flex tw-whitespace-nowrap
            "
          >
            {{ getNightsLabel }}
          </p>
        </div>
      </div>
      <div
        class="
          cruise-modal-itinerary-card-price__amount
          tw-flex tw-flex-wrap tw-flex-col tw-justify-center tw-mt-2.5 tw-ml-16
          2xl:tw-ml-20
          xl:tw-mt-2
          tw-grow
        "
      >
        <div
          class="
            tw-flex tw-w-full tw-justify-center
            lg:tw-justify-start
            tw-h-min
          "
        >
          <span class="cruise-modal-itinerary-card-price__amount__current-price"
            >{{ getPrice }}
          </span>
          <span
            class="
              cruise-modal-itinerary-card-price__amount__price-type
              tw-pl-2 tw-flex tw-flex-col tw-justify-end
            "
          >
            {{ priceType }}
          </span>
          <div
            v-if="isUpliftEnabled"
            class="
              cruise-modal-itinerary-card-price__amount__deposit
              tw-flex tw-justify-center tw-content-center tw-pl-1 tw-mt-2
            "
          >
            <span
              class="
                cruise-modal-itinerary-card-price__amount__deposit__label
                tw-pr-1
              "
              >{{ fromLabel }}</span
            >
            <span
              class="cruise-modal-itinerary-card-price__amount__deposit__price"
              >{{ getUpliftPrice }}</span
            >
            <svg
              class="
                cruise-modal-itinerary-card-price__amount__deposit__info-icon
                tw-ml-0.5
              "
              width="8"
              height="8"
              viewBox="0 0 8 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              @click="openUpliftInfoIcon"
            >
              <path
                d="M3.99996 7.33334C2.15996 7.33334 0.666626 5.84001 0.666626 4.00001C0.666626 2.16001 2.15996 0.666677 3.99996 0.666677C5.83996 0.666677 7.33329 2.16001 7.33329 4.00001C7.33329 5.84001 5.83996 7.33334 3.99996 7.33334ZM4.33329 2.33334H3.66663V3.00001H4.33329V2.33334ZM4.33329 3.66668H3.66663V5.66668H4.33329V3.66668Z"
                fill="#FF690E"
              />
            </svg>
          </div>
        </div>
        <p
          class="cruise-modal-itinerary-card-price__amount__price-note tw-h-min"
        >
          {{ priceNote }}
        </p>
      </div>
      <div
        class="
          cruise-modal-itinerary-card-price__submit-btn
          tw-h-full tw-flex tw-flex-col tw-justify-center
          lg:tw-my-auto
        "
        @click="goToBooking"
      >
        <Button :label="bookNowLabel" :primary="true" :square="true" />
      </div>
    </div>
  </div>
</template>

<script>
import VueImage from "@/stories/Atoms/VueImage/VueImage.vue";
import Button from "@/stories/Atoms/Button/Button";
import Ribbons from "@/stories/Components/CruiseItineraryDetail/Elements/desktop/ribbon/Ribbons.vue";
import { pushOpenUpliftModalEvent } from "@/stories/Components/CruiseItineraryDetail/services/openUpliftInfoModalService";

const dayjs = require("dayjs");

export default {
  name: "ItineraryCard",
  components: {
    Ribbons,
    VueImage,
    Button,
  },
  props: {
    demoMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    portTax: {
      type: Number,
      required: false,
      default: 0,
    },
    labels: {
      type: Object,
      required: true,
      default: () => {},
    },
    numberOfNights: {
      type: Number,
      required: false,
      default: 0,
    },
    startDate: {
      type: String,
      required: false,
      default: "2023-05-20",
    },
    endDate: {
      type: String,
      required: false,
      default: "2023-05-20",
    },
    startPrice: {
      type: Number,
      require: false,
      default: 745,
    },
    price: {
      type: Number,
      require: false,
      default: 538,
    },
    upliftPrice: {
      type: Number,
      required: false,
      default: 14.17,
    },
    isUpliftEnabled: {
      type: Boolean,
      default: true,
      required: false,
    },
    ribbons: {
      type: Array,
      required: false,
      default: () => [],
    },
    itineraryName: {
      type: String,
      required: false,
      default: "Pamper yourself at MSC Ocean Key Marine Reserve",
    },
    itineraryLogo: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    currencyLabel() {
      return this.labels?.cruiseCardCurrencyLabel || "$";
    },
    bookNowLabel() {
      return this.labels?.cruiseCardSubmitButtonLabel;
    },
    getNightsLabel() {
      return `${this.numberOfNights} ${
        this.numberOfNights > 1
          ? this.labels?.cruiseCardNightsLabel
          : this.labels?.cruiseCardNightLabel
      }`;
    },
    getDatesLabel() {
      //May 20 - Jun 14, 2022
      return `${dayjs(this.startDate).format("MMM DD")} - ${dayjs(
        this.endDate
      ).format("MMM DD, YYYY")}`;
    },
    getStartPrice() {
      return `${this.currencyLabel} ${this.startPrice}`;
    },
    getPrice() {
      return `${this.currencyLabel} ${this.price}`;
    },
    fromLabel() {
      return this.labels?.cruiseCardPriceFromLabel;
    },
    priceType() {
      return this.labels?.cruiseCardPriceType;
    },
    priceNote() {
      return this.labels?.cruiseCardPriceNoteLabel?.replace(
        "##TAXES##",
        this.portTax.toString()
      );
    },
    cruiseItineraryLogoAlt() {
      return this.labels?.cruiseCardLogoAltLabel || "Cruise logo";
    },
    upliftMonthLabel() {
      return this.labels?.cruiseCardMobileFooterRangeDepositLabel || "month";
    },
    getUpliftPrice() {
      return `${this.currencyLabel}${this.upliftPrice}/${this.upliftMonthLabel}`;
    },
  },
  methods: {
    goToBooking() {
      if (this.demoMode) return;
      this.$emit("go-to-booking");
    },
    openUpliftInfoIcon() {
      if (!this.demoMode) pushOpenUpliftModalEvent();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "ItineraryCard";
</style>
